"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailTemplateService = void 0;
var _emailTemplate = require("../controllers/emailTemplate.controller");
var emailTemplateService = {
  emailTemplate: {
    list: _emailTemplate.config.emailTemplate + "/list",
    fetch: _emailTemplate.config.emailTemplate,
    add: _emailTemplate.config.emailTemplate,
    delete: _emailTemplate.config.emailTemplate + "/delete/hard",
    softDelete: _emailTemplate.config.emailTemplate + "/delete/soft",
    softDeleteRestore: _emailTemplate.config.emailTemplate + "/delete/soft/restore",
    softDeletedList: _emailTemplate.config.emailTemplate + "/list/soft/deleted",
    bulkDelete: _emailTemplate.config.emailTemplate + "/bulk/delete/hard",
    bulkSoftDelete: _emailTemplate.config.emailTemplate + "/bulk/delete/soft",
    bulkRestore: _emailTemplate.config.emailTemplate + "/bulk/delete/soft/restore",
    restore: _emailTemplate.config.emailTemplate + "/delete/soft/restore"
  }
};
exports.emailTemplateService = emailTemplateService;